import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=823c88fe&"
import script from "./Api.vue?vue&type=script&lang=js&"
export * from "./Api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('823c88fe')) {
      api.createRecord('823c88fe', component.options)
    } else {
      api.reload('823c88fe', component.options)
    }
    module.hot.accept("./Api.vue?vue&type=template&id=823c88fe&", function () {
      api.rerender('823c88fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Api.vue"
export default component.exports